import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import FacebookMediaTemplate from './FacebookMediaTemplate'
import { lang } from '../../assets/lang'

export default class FacebookMediaComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.FACEBOOK_MEDIA)

    this.data.component = FacebookMediaTemplate
    this.socket = config ? config.sockets : null
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.isRcnAddonAvailable = !! window.xitFlowBuilderData.recurring_notification_addon
    this.is_openai_addon_access = !! window.xitFlowBuilderData.is_openai_addon_access
    this.isConditionAddonAvailable = !!window.xitFlowBuilderData.messenger_bot_condition
    this.http_api_module = !! window.xitFlowBuilderData.http_api_module
  }

  builder(node) {
    node.lingualName = lingualName.FACEBOOK_MEDIA
    this.setConnection()

    const facebookMediaInput = new Rete.Input(
      CONST_SOCKET.FACEBOOK_MEDIA_INPUT, 
      lang.facebook_media_socket_input_reply, 
      this.socket.facebookMediaInput,
      true
    )

    const facebookMediaOutput = new Rete.Output(
      CONST_SOCKET.FACEBOOK_MEDIA_OUTPUT, 
      lang.facebook_media_socket_output_next, 
      this.socket.facebookMediaOutput,
      false
    )

    const facebookMediaOutputButton = new Rete.Output(
      CONST_SOCKET.FACEBOOK_MEDIA_OUTPUT_BUTTON, 
      lang.facebook_media_socket_output_buttons, 
      this.socket.facebookMediaOutputButton, 
      true
    )

    const facebookMediaOutputQuickreply = new Rete.Output(
      CONST_SOCKET.FACEBOOK_MEDIA_OUTPUT_QUICKREPLY, 
      lang.facebook_media_socket_output_quick_replies, 
      this.socket.facebookMediaOutputQuickreply, 
      true
    )

    return node
      .addInput(facebookMediaInput)
      .addOutput(facebookMediaOutput)
      .addOutput(facebookMediaOutputButton)
      .addOutput(facebookMediaOutputQuickreply)
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {
    outputs[CONST_SOCKET.FACEBOOK_MEDIA_OUTPUT] = node.data
    outputs[CONST_SOCKET.FACEBOOK_MEDIA_OUTPUT_BUTTON] = node.data
  }
  
  setConnection() {
    // FacebookMedia may be connected to:
    this.socket.facebookMediaOutput.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.facebookMediaOutput.combineWith(this.socket.openaiInput)
    this.socket.facebookMediaOutput.combineWith(this.socket.carouselInput)
    this.socket.facebookMediaOutput.combineWith(this.socket.imageInput)

    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.facebookMediaOutput.combineWith(this.socket.conditionInput)
    }

    if (!this.isInstagramAddonAvailable) {
      this.socket.facebookMediaOutput.combineWith(this.socket.facebookMediaInput)
      this.socket.facebookMediaOutput.combineWith(this.socket.videoInput)
      this.socket.facebookMediaOutput.combineWith(this.socket.audioInput)
      this.socket.facebookMediaOutput.combineWith(this.socket.fileInput)
      // this.socket.facebookMediaOutput.combineWith(this.socket.otnInput)
      if(this.isRcnAddonAvailable)
        this.socket.facebookMediaOutput.combineWith(this.socket.rcnInput)
    }

    this.socket.facebookMediaOutput.combineWith(this.socket.ecommerceInput)
    this.socket.facebookMediaOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.facebookMediaOutput.combineWith(this.socket.componentListInput)

    if(this.http_api_module)
    {
      this.socket.facebookMediaOutput.combineWith(this.socket.httpApiInput)
    }

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.facebookMediaOutput.combineWith(this.socket.userInputFlowInput)
    }

    // FacebookMedia Output: QuickReply, Buttons
    this.socket.facebookMediaOutputButton.combineWith(this.socket.buttonInput)
    this.socket.facebookMediaOutputQuickreply.combineWith(this.socket.quickReplyInput) 
  }
}